import { createTheme } from '@mui/material/styles';

const defaultDataGridTheme = () => createTheme();

export default defaultDataGridTheme;
